import main from '../main.js'
var axios = require('axios')
const url = 'api'
const prefixLocalisation = '/product-localisation/'
const prefixfe = '/product-hut-fe/'
const urlv2 = process.env.host + '/' + process.env.version2
axios.options = {flag: true}
/**
 * Setting url for outlet
 * */
const myaxios = axios.create({
  baseURL: process.env.host + '/' + process.env.version,
  headers: {'Content-Type': 'application/json'}
})
myaxios.interceptors.request.use(
  success => {
    if (myaxios.options.flag) {
      if (success.url != 'mappings') {

      }
      main.$bus.$emit('loading', 'block')
    }
    return success
  },
  error => {
    main.$bus.$emit('loading', 'none')
    console.log('Can not response API server. Please check it again!')
    return Promise.reject(error)
  }
)
myaxios.interceptors.response.use(
  success => {
    myaxios.options.flag = true
    main.$bus.$emit('loading', 'none')
    return success
  },
  error => {
    myaxios.options.flag = true
    main.$bus.$emit('loading', 'none')
    console.log('Can not response API server. Please check it again!')
    return Promise.reject(error)
  }
)
/**
 * Get list outLets for take-away or a outlet for delivery
 * */
myaxios.checkLocation = function (data, success, callBackError) {
  this.get(prefixfe + 'localizations', {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}
/**
 * Get list outLets by postal code
 * */
myaxios.getNextLevelData = function (data, success, callBackError) {
  myaxios.options.flag = false
  this.get(prefixLocalisation + 'search', {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

/**
 * Checking Outlet is available
 * */
myaxios.checkOutletAvailable = function (data, success, callBackError) {
  this.post(urlv2 + prefixfe + 'outlets/available', data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

/**https://api.phdvasia.com/v1/product-hut-fe/opening_hours_summary/5?order_type=C
 * Get outlet's opening hours
 * */
myaxios.getOutletOpeningHours = function (data, success, callBackError) {
  this.get(urlv2 + prefixfe + 'outlets/opening_hours/' + data.outletId, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

/**
 * Get outlets by address code or zipcode or outletid
 * */
myaxios.getOutletByAddressCode = function (data, success, callBackError) {
  this.get(prefixfe + 'mappings', {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

/**
 * Get outlets by outlet code
 * */
myaxios.getOutLetByCode = function (data, success, callBackError) {
  this.get(prefixfe + 'outlets/detail/' + data.code, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 404 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

myaxios.getAddressByAddressCode = function (data, success, callBackError) {
  this.get(prefixfe + 'address/', {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 404 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

myaxios.getListArea = function (success, callBackError) {
  this.get(process.env.host + "/" + process.env.version2 + prefixfe + "localization/getListArea").then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 404 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

myaxios.getBlockByArea = function (data,success, callBackError) {
  this.get(process.env.host + "/" + process.env.version2 + prefixfe + "localization/getBlockByArea?area=" + data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 404 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

myaxios.getOutletsByArea = function (data,success, callBackError) {
  this.get(process.env.host + "/" + 'v1' + prefixfe + "area/list_outlets?name=" + data.name + "&order_type=" + data.order_type).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 404 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

export default myaxios



// WEBPACK FOOTER //
// ./src/api/Outlet.js